import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { RestaurantInfoHeaderSkeleton } from './restaurant-info-header-skeleton';
import { View } from 'react-native';

export const AlertCardSkeleton = () => {
  const [styles] = useStyles();
  return (
    <View
      accessibilityRole="progressbar"
      accessibilityState={{ busy: true }}
      accessible
      style={styles.card}
    >
      <AnimatedSkeletonLoader height={16} width={64} />
      <RestaurantInfoHeaderSkeleton />
      <AnimatedSkeletonLoader height={8} width={265} />
      <AnimatedSkeletonLoader height={8} width={181} />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: 8,
    padding: 16,
  },
}));
